



























import { Vue, Component, Prop } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { INVENTORY_TYPE } from '@/const/types';
import { INativeInventory } from '@/pages/campaign/adset/editingTypes';

@Component<AdsetTableOfNativeInfo>({
    name: 'AdsetTableOfNativeInfo',
})
export default class AdsetTableOfNativeInfo extends Vue {
    @Prop({ type: Array, required: true }) private value!: INativeInventory[];
    
    get targets() { return this.value }
    set targets(v: INativeInventory[]) { this.$emit('input', v) }

    private terms = terms;
    private compTerms = compTerms;
    private INVENTORY_TYPE = INVENTORY_TYPE;
}
